var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	19441: {
		fallback: function() { return __webpack_require__.e(911).then(function() { return function() { return __webpack_require__(70911); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",
	},
	23094: {
		fallback: function() { return __webpack_require__.e(8250).then(function() { return function() { return __webpack_require__(68250); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	66199: {
		fallback: function() { return Promise.all([__webpack_require__.e(6069), __webpack_require__.e(9488), __webpack_require__.e(9129), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(79129); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",
	},
	98314: {
		fallback: function() { return Promise.all([__webpack_require__.e(6069), __webpack_require__.e(5676)]).then(function() { return function() { return __webpack_require__(85676); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	72588: {
		fallback: function() { return Promise.all([__webpack_require__.e(9488), __webpack_require__.e(8766), __webpack_require__.e(3863)]).then(function() { return function() { return __webpack_require__(85259); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	316: {
		fallback: function() { return Promise.all([__webpack_require__.e(2239), __webpack_require__.e(8766)]).then(function() { return function() { return __webpack_require__(42239); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",
	},
	24188: {
		fallback: function() { return __webpack_require__.e(5231).then(function() { return function() { return __webpack_require__(65231); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	56549: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(13274); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react/jsx-runtime",
	},
	668: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(79474); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",
	},
	9228: {
		fallback: function() { return __webpack_require__.e(3254).then(function() { return function() { return __webpack_require__(73254); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",
	},
	68153: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(48088); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",
	},
	28766: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(41615); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",
	},
	21538: {
		fallback: function() { return __webpack_require__.e(578).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.11.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	87819: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "~6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	46357: {
		fallback: function() { return __webpack_require__.e(578).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.9.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	94278: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "6.0.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	17080: {
		fallback: function() { return Promise.all([__webpack_require__.e(7336), __webpack_require__.e(8933), __webpack_require__.e(3804), __webpack_require__.e(6833)]).then(function() { return function() { return __webpack_require__(89042); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "6.0.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	11037: {
		fallback: function() { return Promise.all([__webpack_require__.e(7336), __webpack_require__.e(8933), __webpack_require__.e(3804), __webpack_require__.e(4278), __webpack_require__.e(6833)]).then(function() { return function() { return __webpack_require__(89042); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "~6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	6833: {
		fallback: function() { return __webpack_require__.e(2959).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=11.9.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	40147: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "8.3.16",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	47742: {
		fallback: function() { return __webpack_require__.e(578).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	99317: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(1538), __webpack_require__.e(7819), __webpack_require__.e(6357), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: ">=3.13.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	130: {
		fallback: function() { return __webpack_require__.e(578).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.3",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	36383: {
		fallback: function() { return __webpack_require__.e(2698).then(function() { return function() { return __webpack_require__(52698); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "~6.0.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	20767: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(1538), __webpack_require__.e(7819), __webpack_require__.e(6357), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.14.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	98834: {
		fallback: function() { return Promise.all([__webpack_require__.e(3615), __webpack_require__.e(7336), __webpack_require__.e(6402)]).then(function() { return function() { return __webpack_require__(41484); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "8.3.16",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	86291: {
		fallback: function() { return __webpack_require__.e(578).then(function() { return function() { return __webpack_require__(45340); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.13.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@emotion/react",
	},
	82080: {
		fallback: function() { return Promise.all([__webpack_require__.e(7277), __webpack_require__.e(7029)]).then(function() { return function() { return __webpack_require__(72997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.55.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	17244: {
		fallback: function() { return __webpack_require__.e(5231).then(function() { return function() { return __webpack_require__(65231); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",
	},
	82126: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(1538), __webpack_require__.e(7819), __webpack_require__.e(6357), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.4.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	27268: {
		fallback: function() { return __webpack_require__.e(8250).then(function() { return function() { return __webpack_require__(68250); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",
	},
	1913: {
		fallback: function() { return Promise.all([__webpack_require__.e(3615), __webpack_require__.e(7336), __webpack_require__.e(6402)]).then(function() { return function() { return __webpack_require__(41484); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^8.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	29373: {
		fallback: function() { return Promise.all([__webpack_require__.e(7277), __webpack_require__.e(7029)]).then(function() { return function() { return __webpack_require__(72997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^11.37.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@hackler/react-sdk",
	},
	88972: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(7819), __webpack_require__.e(6357), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.14.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	71312: {
		fallback: function() { return __webpack_require__.e(3295).then(function() { return function() { return __webpack_require__(85676); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",
	},
	38704: {
		fallback: function() { return __webpack_require__.e(7490).then(function() { return function() { return __webpack_require__(17490); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^8.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/hooks",
	},
	43950: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(7819), __webpack_require__.e(6357), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	88821: {
		fallback: function() { return Promise.all([__webpack_require__.e(7336), __webpack_require__.e(8933), __webpack_require__.e(3804), __webpack_require__.e(4278), __webpack_require__.e(6833)]).then(function() { return function() { return __webpack_require__(89042); }; }); },
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "~6.0.22",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@mantine/core",
	},
	19908: {
		fallback: function() { return __webpack_require__.e(5259).then(function() { return function() { return __webpack_require__(85259); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.35",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",
	},
	22011: {
		fallback: function() { return Promise.all([__webpack_require__.e(6506), __webpack_require__.e(3223), __webpack_require__.e(1538), __webpack_require__.e(7819), __webpack_require__.e(4278), __webpack_require__.e(7080)]).then(function() { return function() { return __webpack_require__(43223); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.7.4",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@inflearn/ds-react",
	},
	16187: {
		fallback: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(49906); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/server",
	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [19441,23094,66199,98314,72588,316,24188,56549,668,9228,56549,668,68153,28766,47742,99317,130,11037,66199,36383,20767,98834,40147,86291,82080,17244,46357,82126,27268,1913,87819,29373,21538,88972,1913,71312,38704,94278,17080,1913,71312,43950,1913,71312,71312,1913,71312,1913,71312,88821,1913,71312,1913,71312,1913,71312,19908,19908,1913,19908,71312];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"636": [
		47742,
		99317,
		130,
		11037,
		66199,
		36383,
		20767,
		98834,
		40147,
		86291,
		82080,
		17244
	],
	"1037": [
		11037
	],
	"1312": [
		71312
	],
	"1538": [
		21538
	],
	"2011": [
		22011
	],
	"2126": [
		82126
	],
	"3749": [
		1913,
		71312,
		88821
	],
	"3950": [
		43950
	],
	"4204": [
		1913,
		71312
	],
	"4252": [
		1913,
		19908,
		71312
	],
	"4278": [
		94278
	],
	"4788": [
		19908
	],
	"4836": [
		40147
	],
	"5015": [
		1913,
		71312
	],
	"5527": [
		23094,
		66199,
		98314,
		72588,
		316,
		24188,
		56549,
		668,
		9228
	],
	"5710": [
		1913
	],
	"6187": [
		16187
	],
	"6357": [
		46357
	],
	"6643": [
		1913,
		71312
	],
	"6644": [
		1913,
		71312
	],
	"6742": [
		1913,
		71312,
		19908
	],
	"6833": [
		6833
	],
	"7080": [
		17080
	],
	"7268": [
		27268
	],
	"7819": [
		87819
	],
	"7879": [
		1913,
		71312
	],
	"8022": [
		1913,
		71312
	],
	"8704": [
		38704
	],
	"8766": [
		28766
	],
	"8792": [
		56549,
		668,
		68153,
		28766
	],
	"8972": [
		88972
	],
	"9373": [
		29373
	],
	"9441": [
		19441
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}